/** LinkedIn Images API limits. Reads metadata only; never rewrites the original image. */
export function validateLinkedinImage(bytes:Uint8Array,mime:string):{width:number;height:number;frames:number}{
 const broken=()=>new Error('Billedet er beskadiget eller har et forkert format. Vælg en ny JPG, PNG eller GIF.');
 const need=(offset:number,length:number)=>{if(offset<0||length<0||offset+length>bytes.length)throw broken();};
 const view=new DataView(bytes.buffer,bytes.byteOffset,bytes.byteLength);
 const size=(width:number,height:number,frames=1)=>{
  if(!width||!height)throw broken();
  if(width*height>=36_152_320)throw new Error('LinkedIn kræver færre end 36.152.320 pixels. Gem billedet i en mindre opløsning og vælg det igen.');
  return{width,height,frames};
 };
 if(mime==='image/png'){
  need(0,33);
  if(![137,80,78,71,13,10,26,10,0,0,0,13,73,72,68,82].every((b,i)=>bytes[i]===b))throw broken();
  return size(view.getUint32(16),view.getUint32(20));
 }
 if(mime==='image/jpeg'){
  need(0,4);if(bytes[0]!==255||bytes[1]!==216)throw broken();
  let offset=2;
  while(offset<bytes.length){
   if(bytes[offset++]!==255)throw broken();
   while(bytes[offset]===255)offset++;
   need(offset,1);const marker=bytes[offset++];
   if(marker===0xd9||marker===0xda)break;
   if(marker===0x01||(marker>=0xd0&&marker<=0xd7))continue;
   need(offset,2);const length=view.getUint16(offset);if(length<2)throw broken();need(offset,length);
   if([0xc0,0xc1,0xc2,0xc3,0xc5,0xc6,0xc7,0xc9,0xca,0xcb,0xcd,0xce,0xcf].includes(marker)){
    if(length<8)throw broken();
    return size(view.getUint16(offset+5),view.getUint16(offset+3));
   }
   offset+=length;
  }
  throw broken();
 }
 if(mime==='image/gif'){
  need(0,13);const header=String.fromCharCode(...bytes.subarray(0,6));if(header!=='GIF87a'&&header!=='GIF89a')throw broken();
  const dimensions=size(view.getUint16(6,true),view.getUint16(8,true));
  let offset=13,frames=0;
  const table=(packed:number)=>{if(packed&0x80){const n=3*2**((packed&7)+1);need(offset,n);offset+=n;}};
  const blocks=()=>{while(true){need(offset,1);const n=bytes[offset++];if(!n)return;need(offset,n);offset+=n;}};
  table(bytes[10]);
  while(offset<bytes.length){
   const marker=bytes[offset++];
   if(marker===0x3b){if(!frames)throw broken();return{...dimensions,frames};}
   if(marker===0x21){need(offset,1);offset++;blocks();continue;}
   if(marker!==0x2c)throw broken();
   need(offset,9);size(view.getUint16(offset+4,true),view.getUint16(offset+6,true));
   const packed=bytes[offset+8];offset+=9;table(packed);
   need(offset,1);offset++;blocks();
   if(++frames>250)throw new Error('LinkedIn tillader højst 250 frames i en GIF. Forkort animationen eller vælg et stillbillede.');
  }
  throw broken();
 }
 throw broken();
}
